<!-- 払い戻し完了ダイアログ-->
<template>
  <ItemDialog ref="bookRefundComplete" image-type="done">
    <template #content-area>
      <h2>
        {{ $t("MyTicketTicketing.refundComplete") }}
      </h2>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="returnNativeAppMyticketPage"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogBookRefundComplete",
  methods: {
    async openDialog() {
      this.$refs.bookRefundComplete.open();
    },
    async closeDialog() {
      this.$refs.bookRefundComplete.close();
    },
  },
};
</script>
